// extracted by mini-css-extract-plugin
export default {"btn-box":"FullWidthBtn_btn-box__RDBSo"};